import { IonRouterLink, IonIcon } from '@ionic/react';
import { shield, checkmarkCircle, time, logoRss } from 'ionicons/icons';
import { ProverbOfTheMoment } from './ProverbOfTheMoment';
import { FooterNps } from './FooterNps';
import { LogoLink } from './LogoLink';
import './AppFooter.css';

const LINKS: { label: string; to: string }[] = [
  { label: 'About', to: '/about' },
  { label: 'AI & Matching', to: '/ai-matching' },
  { label: 'Agents', to: '/agents' },
  { label: 'Privacy', to: '/privacy' },
  { label: 'Terms', to: '/terms' },
  { label: 'Contact', to: '/contact' },
  { label: 'Help', to: '/help' },
];

const TRUST = [
  { icon: shield, label: 'POPIA Compliant' },
  { icon: checkmarkCircle, label: 'Verified Employers' },
  { icon: time, label: 'Support Mon–Fri' },
];

export function AppFooter() {
  return (
    <footer className="bp-footer">
      <div className="bp-footer-inner">
        <ProverbOfTheMoment />

        <div className="bp-footer-brand">
          <LogoLink className="bp-footer-logo" style={{ height: '72px' }} />
          <p className="bp-footer-tagline">
            South Africa's contract &amp; project marketplace — connecting skilled people with the work that
            needs them.
          </p>
        </div>

        <nav className="bp-footer-links" aria-label="Footer">
          {LINKS.map((l) => (
            <IonRouterLink key={l.to} className="bp-footer-link" routerLink={l.to}>
              {l.label}
            </IonRouterLink>
          ))}
        </nav>

        <div className="bp-footer-trust">
          {TRUST.map((t) => (
            <span key={t.label} className="bp-footer-trust-item">
              <IonIcon icon={t.icon} className="bp-footer-trust-icon" />
              {t.label}
            </span>
          ))}
        </div>

        <FooterNps />

        <div className="bp-footer-meta">
          <span>&copy; {new Date().getFullYear()} BluePages</span>
          <span className="bp-footer-rosta">
            <IonIcon icon={logoRss} /> Part of the Rosta platform
          </span>
        </div>
      </div>
    </footer>
  );
}
